import { render, staticRenderFns } from "./AgreementLanguage.vue?vue&type=template&id=058a52c0&scoped=true&"
import script from "./AgreementLanguage.vue?vue&type=script&lang=js&"
export * from "./AgreementLanguage.vue?vue&type=script&lang=js&"
import style0 from "./AgreementLanguage.vue?vue&type=style&index=0&id=058a52c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058a52c0",
  null
  
)

export default component.exports